// useFixtureRotateGizmo.js
//
// Armatür (LightFixture) için rotate gizmo'sunun visibility yönetimi.
// useSocketGizmo / useLightSwitchGizmo ile aynı pattern: seçili fixture'ın
// rotateGizmo child'ını visible=true yapar, aksi durumda false.
//
// Not: useFixtureGizmo (mevcut dosya) wire spline control point gizmo'larını
// yönetir — fixture mesh rotate'iyle alakası yok. Bu hook ayrıdır.

import { useEffect } from 'react';

export default function useFixtureRotateGizmo(scene, selectedObjectIds) {
  useEffect(() => {
    if (!scene || !Array.isArray(selectedObjectIds)) return;
    scene.traverse(obj => {
      if (obj.userData?.type !== 'LightFixture') return;
      const isSelected = selectedObjectIds.includes(obj.userData?.id);
      obj.traverse(child => {
        if (child.userData?.type === 'rotateGizmo') child.visible = isSelected;
      });
    });
  }, [scene, selectedObjectIds]);
}
